import React from "react";
import Router from '../src/componentes/utilidades/rutas'


function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
